import { render, staticRenderFns } from "./NotOpen.vue?vue&type=template&id=0b569fc5&scoped=true&lang=html"
import script from "./NotOpen.vue?vue&type=script&lang=js"
export * from "./NotOpen.vue?vue&type=script&lang=js"
import style0 from "./NotOpen.vue?vue&type=style&index=0&id=0b569fc5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b569fc5",
  null
  
)

export default component.exports